/**
 * Shared Share/Export menu icons — same SVGs as CollectionRowHeader ⋯ menu.
 */
export const ActivityShareDownloadIcon = () => (
  <svg
    width="11"
    height="11"
    viewBox="0 0 11 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M5.33333 8L2 4.66667L2.93333 3.7L4.66667 5.43333V0H6V5.43333L7.73333 3.7L8.66667 4.66667L5.33333 8ZM1.33333 10.6667C0.966667 10.6667 0.652778 10.5361 0.391667 10.275C0.130556 10.0139 0 9.7 0 9.33333V7.33333H1.33333V9.33333H9.33333V7.33333H10.6667V9.33333C10.6667 9.7 10.5361 10.0139 10.275 10.275C10.0139 10.5361 9.7 10.6667 9.33333 10.6667H1.33333Z"
      fill="#222222"
    />
  </svg>
);

export const ActivityShareEmailIcon = () => (
  <svg
    width="14"
    height="11"
    viewBox="0 0 14 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M1.33333 10.6667C0.966667 10.6667 0.652778 10.5361 0.391667 10.275C0.130556 10.0139 0 9.7 0 9.33333V1.33333C0 0.966667 0.130556 0.652778 0.391667 0.391667C0.652778 0.130556 0.966667 0 1.33333 0H12C12.3667 0 12.6806 0.130556 12.9417 0.391667C13.2028 0.652778 13.3333 0.966667 13.3333 1.33333V9.33333C13.3333 9.7 13.2028 10.0139 12.9417 10.275C12.6806 10.5361 12.3667 10.6667 12 10.6667H1.33333ZM6.66667 6L1.33333 2.66667V9.33333H12V2.66667L6.66667 6ZM6.66667 4.66667L12 1.33333H1.33333L6.66667 4.66667ZM1.33333 2.66667V1.33333V9.33333V2.66667Z"
      fill="#222222"
    />
  </svg>
);

export const ActivityCompleteInfoIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="shrink-0"
    aria-hidden
  >
    <path
      d="M3.25 1.75h4.5l3 3v6.75c0 .55-.45 1-1 1H3.25c-.55 0-1-.45-1-1V2.75c0-.55.45-1 1-1z"
      stroke="#222222"
      strokeWidth="1.25"
      strokeLinejoin="round"
      fill="white"
    />
    <path
      d="M7.75 1.75V4.75h3"
      stroke="#222222"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M3.75 6.75h4.25M3.75 8.75h4.25M3.75 10.75h2.75"
      stroke="#222222"
      strokeWidth="1"
      strokeLinecap="round"
    />
    <path
      d="M9.5 8.25l2.75 2.75-1.15 1.15-2.75-2.75L9.5 8.25z"
      stroke="#222222"
      strokeWidth="1"
      strokeLinejoin="round"
      fill="white"
    />
    <path
      d="M11.35 9.1l.55.55"
      stroke="#222222"
      strokeWidth="1"
      strokeLinecap="round"
    />
  </svg>
);

export const ActivityUploadFileIcon = () => (
  <svg
    width="11"
    height="14"
    viewBox="0 0 11 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="shrink-0"
    aria-hidden
  >
    <path
      d="M2.66667 10.6667H8V9.33333H2.66667V10.6667ZM2.66667 8H8V6.66667H2.66667V8ZM1.33333 13.3333C0.966667 13.3333 0.652778 13.2028 0.391667 12.9417C0.130556 12.6806 0 12.3667 0 12V1.33333C0 0.966667 0.130556 0.652778 0.391667 0.391667C0.652778 0.130556 0.966667 0 1.33333 0H6.66667L10.6667 4V12C10.6667 12.3667 10.5361 12.6806 10.275 12.9417C10.0139 13.2028 9.7 13.3333 9.33333 13.3333H1.33333ZM6 4.66667V1.33333H1.33333V12H9.33333V4.66667H6Z"
      fill="#222222"
    />
  </svg>
);

export const ActivityCharacterizeIcon = () => (
  <svg
    width="14"
    height="11"
    viewBox="0 0 14 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="shrink-0"
    aria-hidden
  >
    <path
      d="M1.33333 10.6667C0.966667 10.6667 0.652778 10.5361 0.391667 10.275C0.130556 10.0139 0 9.7 0 9.33333V1.33333C0 0.966667 0.130556 0.652778 0.391667 0.391667C0.652778 0.130556 0.966667 0 1.33333 0H4.78333C4.96111 0 5.13056 0.0333333 5.29167 0.1C5.45278 0.166667 5.59444 0.261111 5.71667 0.383333L6.66667 1.33333H12C12.3667 1.33333 12.6806 1.46389 12.9417 1.725C13.2028 1.98611 13.3333 2.3 13.3333 2.66667V9.33333C13.3333 9.7 13.2028 10.0139 12.9417 10.275C12.6806 10.5361 12.3667 10.6667 12 10.6667H1.33333ZM1.33333 9.33333H12V2.66667H6.11667L4.78333 1.33333H1.33333V9.33333ZM8.33333 8.66667H9.66667C9.94444 8.66667 10.1806 8.56944 10.375 8.375C10.5694 8.18056 10.6667 7.94444 10.6667 7.66667V5H10.8333C10.9778 5 11.0972 4.95278 11.1917 4.85833C11.2861 4.76389 11.3333 4.64444 11.3333 4.5C11.3333 4.35556 11.2861 4.23611 11.1917 4.14167C11.0972 4.04722 10.9778 4 10.8333 4H9.66667V3.66667C9.66667 3.57778 9.63333 3.5 9.56667 3.43333C9.5 3.36667 9.42222 3.33333 9.33333 3.33333H8.66667C8.57778 3.33333 8.5 3.36667 8.43333 3.43333C8.36667 3.5 8.33333 3.57778 8.33333 3.66667V4H7.16667C7.02222 4 6.90278 4.04722 6.80833 4.14167C6.71389 4.23611 6.66667 4.35556 6.66667 4.5C6.66667 4.64444 6.71389 4.76389 6.80833 4.85833C6.90278 4.95278 7.02222 5 7.16667 5H7.33333V7.66667C7.33333 7.94444 7.43056 8.18056 7.625 8.375C7.81944 8.56944 8.05556 8.66667 8.33333 8.66667ZM8.33333 5H9.66667V7.66667H8.33333V5Z"
      fill="#222222"
    />
  </svg>
);

export const ActivityTagIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="shrink-0"
    aria-hidden
  >
    <path
      d="M12.9333 8.16667L8.16667 12.9333C8.03333 13.0667 7.88333 13.1667 7.71667 13.2333C7.55 13.3 7.38333 13.3333 7.21667 13.3333C7.05 13.3333 6.88333 13.3 6.71667 13.2333C6.55 13.1667 6.4 13.0667 6.26667 12.9333L0.383333 7.05C0.261111 6.92778 0.166667 6.78611 0.1 6.625C0.0333333 6.46389 0 6.29444 0 6.11667V1.33333C0 0.966667 0.130556 0.652778 0.391667 0.391667C0.652778 0.130556 0.966667 0 1.33333 0H6.11667C6.29444 0 6.46667 0.0361111 6.63333 0.108333C6.8 0.180556 6.94444 0.277778 7.06667 0.4L12.9333 6.28333C13.0667 6.41667 13.1639 6.56667 13.225 6.73333C13.2861 6.9 13.3167 7.06667 13.3167 7.23333C13.3167 7.4 13.2861 7.56389 13.225 7.725C13.1639 7.88611 13.0667 8.03333 12.9333 8.16667ZM7.21667 12L11.9833 7.23333L6.1 1.33333H1.33333V6.1L7.21667 12ZM3 4C3.27778 4 3.51389 3.90278 3.70833 3.70833C3.90278 3.51389 4 3.27778 4 3C4 2.72222 3.90278 2.48611 3.70833 2.29167C3.51389 2.09722 3.27778 2 3 2C2.72222 2 2.48611 2.09722 2.29167 2.29167C2.09722 2.48611 2 2.72222 2 3C2 3.27778 2.09722 3.51389 2.29167 3.70833C2.48611 3.90278 2.72222 4 3 4Z"
      fill="#222222"
    />
  </svg>
);

export const ActivityContainerSettingsIcon = () => (
  <svg
    width="13"
    height="14"
    viewBox="0 0 13 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="shrink-0"
    aria-hidden
  >
    <path
      d="M5.56333 13.3333C5.26333 13.3333 5.005 13.2333 4.78833 13.0333C4.57167 12.8333 4.44111 12.5889 4.39667 12.3L4.24667 11.2C4.10222 11.1444 3.96611 11.0778 3.83833 11C3.71056 10.9222 3.58556 10.8389 3.46333 10.75L2.43 11.1833C2.15222 11.3056 1.87444 11.3167 1.59667 11.2167C1.31889 11.1167 1.10222 10.9389 0.946667 10.6833L0.163333 9.31667C0.00777778 9.06111 -0.0366667 8.78889 0.03 8.5C0.0966667 8.21111 0.246667 7.97222 0.48 7.78333L1.36333 7.11667C1.35222 7.03889 1.34667 6.96389 1.34667 6.89167V6.44167C1.34667 6.36944 1.35222 6.29444 1.36333 6.21667L0.48 5.55C0.246667 5.36111 0.0966667 5.12222 0.03 4.83333C-0.0366667 4.54444 0.00777778 4.27222 0.163333 4.01667L0.946667 2.65C1.10222 2.39444 1.31889 2.21667 1.59667 2.11667C1.87444 2.01667 2.15222 2.02778 2.43 2.15L3.46333 2.58333C3.58556 2.49444 3.71333 2.41111 3.84667 2.33333C3.98 2.25556 4.11333 2.18889 4.24667 2.13333L4.39667 1.03333C4.44111 0.744444 4.57167 0.5 4.78833 0.3C5.005 0.1 5.26333 0 5.56333 0H7.13C7.43 0 7.68833 0.1 7.905 0.3C8.12167 0.5 8.25222 0.744444 8.29667 1.03333L8.44667 2.13333C8.59111 2.18889 8.72722 2.25556 8.855 2.33333C8.98278 2.41111 9.10778 2.49444 9.23 2.58333L10.2633 2.15C10.5411 2.02778 10.8189 2.01667 11.0967 2.11667C11.3744 2.21667 11.5911 2.39444 11.7467 2.65L12.53 4.01667C12.6856 4.27222 12.73 4.54444 12.6633 4.83333C12.5967 5.12222 12.4467 5.36111 12.2133 5.55L11.33 6.21667C11.3411 6.29444 11.3467 6.36944 11.3467 6.44167V6.89167C11.3467 6.96389 11.3356 7.03889 11.3133 7.11667L12.1967 7.78333C12.43 7.97222 12.58 8.21111 12.6467 8.5C12.7133 8.78889 12.6689 9.06111 12.5133 9.31667L11.7133 10.6833C11.5578 10.9389 11.3411 11.1167 11.0633 11.2167C10.7856 11.3167 10.5078 11.3056 10.23 11.1833L9.23 10.75C9.10778 10.8389 8.98 10.9222 8.84667 11C8.71333 11.0778 8.58 11.1444 8.44667 11.2L8.29667 12.3C8.25222 12.5889 8.12167 12.8333 7.905 13.0333C7.68833 13.2333 7.43 13.3333 7.13 13.3333H5.56333ZM5.68 12H6.99667L7.23 10.2333C7.57444 10.1444 7.89389 10.0139 8.18833 9.84167C8.48278 9.66944 8.75222 9.46111 8.99667 9.21667L10.6467 9.9L11.2967 8.76667L9.86333 7.68333C9.91889 7.52778 9.95778 7.36389 9.98 7.19167C10.0022 7.01944 10.0133 6.84444 10.0133 6.66667C10.0133 6.48889 10.0022 6.31389 9.98 6.14167C9.95778 5.96944 9.91889 5.80556 9.86333 5.65L11.2967 4.56667L10.6467 3.43333L8.99667 4.13333C8.75222 3.87778 8.48278 3.66389 8.18833 3.49167C7.89389 3.31944 7.57444 3.18889 7.23 3.1L7.01333 1.33333H5.69667L5.46333 3.1C5.11889 3.18889 4.79944 3.31944 4.505 3.49167C4.21056 3.66389 3.94111 3.87222 3.69667 4.11667L2.04667 3.43333L1.39667 4.56667L2.83 5.63333C2.77444 5.8 2.73556 5.96667 2.71333 6.13333C2.69111 6.3 2.68 6.47778 2.68 6.66667C2.68 6.84444 2.69111 7.01667 2.71333 7.18333C2.73556 7.35 2.77444 7.51667 2.83 7.68333L1.39667 8.76667L2.04667 9.9L3.69667 9.2C3.94111 9.45556 4.21056 9.66944 4.505 9.84167C4.79944 10.0139 5.11889 10.1444 5.46333 10.2333L5.68 12ZM6.38 9C7.02444 9 7.57444 8.77222 8.03 8.31667C8.48556 7.86111 8.71333 7.31111 8.71333 6.66667C8.71333 6.02222 8.48556 5.47222 8.03 5.01667C7.57444 4.56111 7.02444 4.33333 6.38 4.33333C5.72444 4.33333 5.17167 4.56111 4.72167 5.01667C4.27167 5.47222 4.04667 6.02222 4.04667 6.66667C4.04667 7.31111 4.27167 7.86111 4.72167 8.31667C5.17167 8.77222 5.72444 9 6.38 9Z"
      fill="#222222"
    />
  </svg>
);

/**
 * Build Share export entries in the canonical order: PDF, CSV, email.
 * Labels match the activity row ⋯ menu.
 */
export const buildActivityShareExportItems = ({
  t,
  onRequestPdf,
  onRequestCsv,
  onRequestEmail,
}) => [
  {
    key: "pdf",
    label: "PDF",
    icon: <ActivityShareDownloadIcon />,
    menuIcon: <ActivityShareDownloadIcon />,
    onClick: onRequestPdf,
  },
  {
    key: "csv",
    label: "CSV",
    icon: <ActivityShareDownloadIcon />,
    menuIcon: <ActivityShareDownloadIcon />,
    onClick: onRequestCsv,
  },
  {
    key: "email",
    label: t("Share by email"),
    icon: <ActivityShareEmailIcon />,
    menuIcon: <ActivityShareEmailIcon />,
    onClick: onRequestEmail,
  },
];
